import Dhruvesh from '../../assets/Images/Dhruvesh.jpg'
import Reanlo from '../../assets/Images/Reanlo.jpg'
import Vypar from '../../assets/Images/Vyapar.png'
import Shoes from '../../assets/Images/Shoes.jpg'
import Tic from '../../assets/Images/Tic.jpeg'


const logotext = "Dhruvesh Rana";
const meta = {
  title: "Dhruvesh Rana",
  description:
    "I’m Dhruvesh Rana Full stack devloper,currently working in Berlin",
};

const introdata = {
  title: "I’m Dhruvesh Rana",
  animated: {
    third: "I develop mobile apps",
    second: "I code cool websites",
    Forth: "I Work as a Quality Assurance",
  },
  description: "I am a highly skilled and dedicated software developer specializing in React Native and React.js, currently employed at Groovy Web Tec Ltd. in Nadiad. With a strong foundation in front-end development and a passion for creating intuitive, user-friendly applications, I bring a wealth of experience and expertise to every project I undertake.",
  // "I am a highly skilled and dedicated software developer specializing in React Native and React.js, currently employed at Groovy Web Tec Ltd. in Nadiad. With a strong foundation in front-end development and a passion for creating intuitive, user-friendly applications, I bring a wealth of experience and expertise to every project I undertake.At Groovy Web Tec Ltd., I leverage my deep understanding of modern web and mobile technologies to design and develop robust, scalable applications that meet the highest standards of performance and reliability. My work is characterized by a meticulous attention to detail, a commitment to best practices, and a relentless pursuit of excellence.",
  your_img_url: "https://images.unsplash.com/photo-1514790193030-c89d266d5a9d",
  description2: "I am a highly skilled and dedicated software developer specializing in React Native and React.js, currently employed at Groovy Web Tec Ltd. in Nadiad. With a strong foundation in front-end development and a passion for creating intuitive, user-friendly applications, I bring a wealth of experience and expertise to every project I undertake. At Groovy Web Tec Ltd., I leverage my deep understanding of modern web and mobile technologies to design and develop robust, scalable applications that meet the highest standards of performance and reliability. My work is characterized by a meticulous attention to detail, a commitment to best practices, and a relentless pursuit of excellence"
};

const dataabout = {
  title: "abit about my self",
  aboutme:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent quis dolor id ligula semper elementum feugiat pretium nulla. Nunc non commodo dolor. Nunc mollis dignissim facilisis. Morbi ut magna ultricies.",
};

const data = [
  {
    id: 1,
    Image: Reanlo,
    title: "Reanlo For Readers ",
    description: 'Reanlo is a cutting-edge book management application designed to enhance your reading experience and streamline your book collection management.',
    title2: 'About App',
    description2: 'Reanlo is a mobile application similar to Instagram but designed specifically for book enthusiasts. Users can share book reviews, follow other readers, and keep track of their reading progress. The app provides a platform for users to engage with book-related content and connect with like-minded individuals.',

    title3: 'Role',
    Role: "Junior Developer",
    title4: 'Technologies',

    Technologies: " React Native, Redux, REST API",
    title5: 'OtherDetail',
    OtherDetail: "Reanlo is a professional book-centric social media platform, akin to Instagram but tailored for book lovers. Users can create and share posts about books, engage with comments, and receive notifications for interactions. The app includes an intuitive admin panel for content management, a detailed book information page, and a discover section to explore new books. Users can follow and unfollow authors and fellow readers, fostering a community of book enthusiasts. Reanlo blends the interactive features of social media with the rich content of book discussions, making it a go-to platform for book lovers.",

  },
  {
    id: 2,
    Image: Vypar,
    title: "Business Maintenance",
    description: 'Business Maintenance is an intuitive business management application designed to streamline your operations. With Vyapar, you can effortlessly manage your inventory, dealers, and customer relationships all in one place.',
    title2: 'About App',
    description2: 'This web application is designed for businesses to manage their billing, customer, and dealer information efficiently. Users can add new bills, manage customer and dealer information, and create bills by adding products. The application streamlines business operations by storing all customer data securely in a database and providing a user-friendly interface for daily tasks.',
    title3: 'Role',

    Role: "Sole Developer",
    title4: 'Technologies',

    Technologies: "React, Redux, Firebase",
    title5: 'OtherDetail',
    OtherDetail: "Business Maintenance is a comprehensive application designed to streamline business operations. It allows users to create dynamic bills tailored to customer needs, manage customer and product information, and efficiently track transactions. The app features a detailed View Bill section, where users can monitor customer accounts, distinguishing between pending and cleared amounts, ensuring accurate financial tracking.",
    OtherDetail2: "Additionally, the application includes functionality to add and manage dealer information. In the dealer section, users can log incoming goods and associate them with specific bills, providing a clear overview of inventory and supplier transactions. This feature mirrors the efficiency of the View Bill section, offering a unified experience across the platform.",
    OtherDetail3: "With its robust functionality, Business Maintenance empowers businesses to maintain accurate records, optimize transactions, and enhance overall operational efficiency."
  },
  {
    id: 3,
    Image: Shoes,
    title: "Shoes App",
    description: 'The Shoes App is a modern, user-friendly platform designed to enhance your shopping experience for footwear. It allows users to effortlessly browse through a curated selection of shoes, with features tailored for convenience and personalization',
    title2: 'About App',
    description2: 'This web application is designed for businesses to manage their billing, customer, and dealer information efficiently. Users can add new bills, manage customer and dealer information, and create bills by adding products. The application streamlines business operations by storing all customer data securely in a database and providing a user-friendly interface for daily tasks.',
    title3: 'Role',

    Role: "Sole Developer",
    title4: 'Technologies',

    Technologies: "React Native, Redux, Firebase",
    title5: 'OtherDetail',
    OtherDetail: "Select Your Shoes: Explore a wide variety of shoes, from casual sneakers to formal wear, with detailed product descriptions, high-quality images, and user reviews to help you make the best choice. ",
    OtherDetail2: "Add to Cart: Seamlessly add your favorite pairs to the cart, with options to adjust quantities, select sizes, and apply discounts or promo codes at checkout.",
    OtherDetail3: " Add to Favorites: Save your preferred choices to a personalized favorites list, allowing you to revisit and purchase them later with ease.",
  },
  {
    id: 4,
    Image: Tic,
    title: "4x4 Tic Tac Toe App",
    description: 'Create for my fun Experience a fresh take on Tic Tac Toe with a 4x4 grid, offering a more complex and challenging gameplay compared to the classic 3x3 version.',
    title2: 'About App',
    description2: 'Elevate your classic Tic Tac Toe experience with our innovative 4x4 Tic Tac Toe Challenge! Designed for enthusiasts seeking a more strategic and engaging twist on the traditional game, this app brings you a larger grid and exciting new gameplay dynamics.',
    title3: 'Role',

    Role: "Sole Developer",
    title4: 'Technologies',

    Technologies: "React Native, Redux, Firebase",
  },


]

const skills = [
  {
    name: "React Js",
    value: 70,
  },
  {
    name: "React Native",
    value: 80,
  },
  {
    name: "Javascript",
    value: 80,
  },
  {
    name: "Rest Api",
    value: 85,
  },
  {
    name: "Redux",
    value: 85,
  },
  {
    name: "Manual Testing",
    value: 80,
  },
  {
    name: "Firebase",
    value: 75,
  },
];

const services = [
  {
    title: "Mobile Apps",
    description:
      "I specialize in creating highly effective and user-centric mobile applications. My focus is on delivering seamless, responsive, and engaging apps that enhance user experience. With a deep understanding of React Native, I develop apps that are both functional and aesthetically pleasing, tailored to meet the unique needs of each client.",
  },
  {
    title: "WebSite Design",
    description:
      "As a skilled React developer, I create dynamic, responsive, and high-performance web applications. My expertise lies in building user-friendly interfaces that are both visually appealing and highly functional. I am dedicated to delivering tailored solutions that meet the specific needs of each project, ensuring an optimal user experience across all platforms.",
  },
  {
    title: "Testing (Manual)",
    description:
      "I excel in manual testing, ensuring that applications are thoroughly tested for functionality, usability, and performance. My approach is meticulous and detail-oriented, focusing on identifying and addressing potential issues before they impact the end user. By rigorously testing every aspect of the application, I ensure a high level of quality and reliability in the final product.",
  },
];

const dataportfolio = [
  {
    img: "https://picsum.photos/400/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/800/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/600/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/300/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/700/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },

  {
    img: "https://picsum.photos/400/600/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/300/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/550/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
  {
    img: "https://picsum.photos/400/700/?grayscale",
    description:
      "The wisdom of life consists in the elimination of non-essentials.",
    link: "#",
  },
];

const contactConfig = {
  YOUR_EMAIL: "dhrurana96@gmail.com",
  YOUR_FONE: "8511587821",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vehicula eu nunc et sollicitudin. Cras pulvinar, nisi at imperdiet pharetra. ",
  // creat an emailjs.com account
  // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
  YOUR_SERVICE_ID: "service_id",
  YOUR_TEMPLATE_ID: "template_id",
  YOUR_USER_ID: "user_id",
};

const socialprofils = {
  github: "https://github.com",
  facebook: "https://facebook.com",
  linkedin: "https://linkedin.com",
};
export {
  meta,
  dataabout,
  data,
  dataportfolio,
  skills,
  services,
  introdata,
  contactConfig,
  socialprofils,
  logotext,
};
